<template>
  <div>
    <router-view class="main" />

    <van-tabbar v-model="tabActive" route>
      <van-tabbar-item v-show="isLogin" replace to="/myClient" icon="contact-o">我的客户</van-tabbar-item>
      <van-tabbar-item v-show="duty == 3 || duty == 4| duty == 99" replace to="/myTeam" icon="friends-o">我的团队</van-tabbar-item>
      <!-- <van-tabbar-item v-show="duty == 99" replace to="/registerProcess" icon="todo-list-o">注册审核</van-tabbar-item> -->
      <van-tabbar-item v-show="duty == 99" replace to="/remindConfig" icon="setting-o">配置信息</van-tabbar-item>
      <van-tabbar-item v-show="isLogin" replace to="/adminAccount" icon="contact">我的</van-tabbar-item>
    </van-tabbar>

  </div> 
</template>

<script>
import request from "@/utils/request";
import useCache from "@/utils/user";


export default {
  components: {
  },
  data() {
    return {
      isLogin: useCache.isLogin(),
      duty: -1,
      tabActive: 0,
    };
  },
  created() {
    if (useCache.isLogin()) {
      request.get("/User/AccountMng/GetUserInfo").then((res) => {
        useCache.cacheUserData(res.data.data);
        this.isLogin = useCache.isLogin()
        this.duty = res.data.data.duty
        this.tabActive = 0
      });
    } else {
      this.$router.replace({
        name: 'login',
        query: { source: 'main' }
      })
    }
  },
  methods: {
  
  }
};
</script>

<style lang="less">
.main {
  padding-bottom: 150px;
}
</style>
